import { createImg } from "../../../../DomUtilities/ElementsCreator";

export default class DescriptionModal {
	modalDiv: HTMLDivElement;
	infoDiv: HTMLDivElement;

	constructor() {
		this.modalDiv = document.querySelector("#description-modal");
		this.infoDiv = this.modalDiv.querySelector("#info");

		this.addModalClickListeners();
	}

	public openModal(text: string, image: string) {
		this.infoDiv.innerHTML = "";
		if (image) {
			const img = createImg(image);
			this.infoDiv.appendChild(img);
		}
		const descriptionText = document.createElement('p');
		if (text) {
			descriptionText.innerText = text;
		} else {
			descriptionText.innerText = this.infoDiv.dataset.empty;
		}
		this.infoDiv.appendChild(descriptionText);
		this.modalDiv.style.display = "flex";
	}

	private addModalClickListeners() {
		const closeImg: HTMLImageElement = this.modalDiv.querySelector('img[alt="close icon"]');

		document.body.onclick = (event) => {
			if (event.target === this.modalDiv) {
				this.modalDiv.style.display = "none";
			}
		}

		closeImg.onclick = () => {
			this.modalDiv.style.display = "none";
		}
	}
}
